{
  "Branding_Labels_BrandingEnabled": "Branding für dieses CME aktivieren?",
  "Branding_Tab_Name_Colours": "Farben",
  "Branding_Tab_Name_AdditionalColours": "Andere Farben",
  "Branding_Tab_Name_Imagery": "Bildmaterial",
  "Branding_Tab_Name_Languages": "Sprache",
  "Branding_Tab_Name_SSOButtons": "SSO-Schaltflächen",
  "Branding_Tab_Name_Links": "Links",
  "Branding_Labels_DarkMode": "(Dunkelmodus)",
  "Branding_Subtitles_ColourPalette": "Farbpalette",
  "Branding_Labels_PrimaryColour": "Primär",
  "Branding_Labels_SecondaryColour": "Sekundär",
  "Branding_Labels_TertiaryColour": "Tertiär",
  "Branding_Subtitles_HeaderSidebarColours": "Kopfzeilen-\/Seitenleistenfarben",
  "Branding_Labels_HeaderSidebarBackgroundColour": "Kopfzeilen-\/Seitenleistenhintergrund",
  "Branding_Labels_HeaderSidebarBackgroundContrastColour": "Akzent für Kopf-\/Seitenleiste",
  "Branding_Labels_HeaderSidebarIconColour": "Kopfzeilen-\/Seitenleistensymbole",
  "Branding_Subtitles_RouterColours": "Routerfarben",
  "Branding_Labels_RouterLoaderBackgroundColour": "Router Loader-Hintergrund",
  "Branding_Labels_RouterLoaderForegroundColour": "Router Loader Vordergrund",
  "Branding_Subtitles_DashboardColours": "Armaturenbrettfarben",
  "Branding_Labels_Dashboard_1_BgColour": "Dashboard 1 – Hintergrund",
  "Branding_Labels_Dashboard_1_FgColour": "Dashboard 1 Vordergrund",
  "Branding_Labels_Dashboard_2_BgColour": "Dashboard 2 – Hintergrund",
  "Branding_Labels_Dashboard_2_FgColour": "Dashboard 2 Vordergrund",
  "Branding_Labels_Dashboard_3_BgColour": "Dashboard 3 – Hintergrund",
  "Branding_Labels_Dashboard_3_FgColour": "Dashboard 3 Vordergrund",
  "Branding_Labels_Dashboard_4_BgColour": "Dashboard 4 – Hintergrund",
  "Branding_Labels_Dashboard_4_FgColour": "Dashboard 4 Vordergrund",
  "Branding_Labels_Dashboard_5_BgColour": "Dashboard 5 – Hintergrund",
  "Branding_Labels_Dashboard_5_FgColour": "Dashboard 5 Vordergrund",
  "Branding_Labels_Dashboard_6_BgColour": "Dashboard 6 – Hintergrund",
  "Branding_Labels_Dashboard_6_FgColour": "Dashboard 6 Vordergrund",
  "Branding_Subtitles_AuthColours": "Autorisierungsfarben",
  "Branding_Labels_Auth_Subtitle_HighlightColour": "Autorisierungs-Hervorhebungsfarbe",
  "Branding_Subtitles_InsightsColours": "Einblicke Farben",
  "Branding_Labels_Insights_Stat_1_Colour": "Insights-Statistik 1",
  "Branding_Labels_Insights_Stat_2_Colour": "Insights-Statistik 2",
  "Branding_Labels_Insights_Stat_3_Colour": "Insights-Statistik 3",
  "Branding_Labels_Insights_Stat_4_Colour": "Insights-Statistik 4",
  "Branding_Labels_Insights_Stat_5_Colour": "Insights-Statistik 5",
  "Branding_Labels_Insights_Percentage_Increase": "Änderungsindikator - Verbesserung",
  "Branding_Labels_Insights_Percentage_Decrease": "Änderungsindikator - Rückgang",
  "Branding_Labels_Insights_Percentage_NoChange": "Keine Änderungsanzeige",
  "Branding_Labels_Insights_Quick_BusiestDay": "Einblicke in den geschäftigsten Tag",
  "Branding_Labels_Insights_Quick_BusiestTime": "Einblicke in die geschäftigste Zeit",
  "Branding_Labels_Highlights_MostCalled": "Highlights Meistgerufen",
  "Branding_Labels_Highlights_MostAnsweredCalls": "Hebt die am häufigsten beantworteten Anrufe hervor",
  "Branding_Subtitles_CompanyLogos": "Firmenlogos",
  "Branding_Labels_Imagery_MainLogo": "Hauptlogo (für dunklen Hintergrund)",
  "Branding_Labels_Imagery_MainLogo_White": "Hauptlogo (für auf weißem Hintergrund)",
  "Branding_Labels_Imagery_Favicon": "Favicon (.ico-Datei)",
  "Branding_Labels_Imagery_SquareLogo": "Quadratisches Logo",
  "Branding_Labels_Imagery_BroadworksLogo": "Broadworks Logo",
  "Branding_Subtitles_Authorisation": "Autorisierungsbilder",
  "Branding_Labels_Imagery_AuthBg": "Autorisierungshintergrund (Bild oder Video)",
  "Branding_Subtitle_AuthLanguages": "Anmeldeseite",
  "Branding_Labels_AuthTitle": "Untertitel der Anmeldeseite",
  "Branding_Labels_AuthTitle2": "Untertitelzeile 2 der Anmeldeseite",
  "Branding_Subtitle_Broadworks": "Broadworks",
  "Branding_Labels_BroadworksName": "Broadworks-Name",
  "Branding_Subtitle_SSOButtons": "SSO-Schaltflächen",
  "Branding_Labels_SSOIcon": "Symbol",
  "Branding_Labels_SSOLabel": "Etikett",
  "Branding_Labels_SSOUrl": "URL",
  "Branding_Labels_MainSiteLink": "Link zur Hauptsite",
  "Branding_Validation_MustBeValidURL": "Muss eine gültige URL sein",
  "Branding_SSO_Buttons_Add": "SSO-Schaltfläche hinzufügen",
  "Branding_SSO_Buttons_Remove": "Schaltfläche „SSO entfernen“",
  "Branding_Labels_VanityURL": "URL",
  "Branding_ResetButton": "Auf vorherige Version zurücksetzen",
  "Branding_RestoreCurrentVersion": "Zurück zur aktuellen Version",
  "Branding_ApplyPreviewButton": "Klicken Sie hier, um eine Vorschau anzuzeigen",
  "Branding_PreviewButton": "Es ist eine Entwurfsversion verfügbar. Klicken Sie hier, um eine Vorschau anzuzeigen.",
  "Branding_DeletePreview": "Vorschau löschen",
  "Branding_UndoChanges": "Aktuelle Änderungen löschen",
  "Branding_Required_Message": "Dieses Feld ist erforderlich",
  "Branding_Submission_Line1": "Wir erstellen Ihr Branding für Sie",
  "Branding_Submission_Line2": "Dies kann einige Sekunden dauern",
  "Branding_Validation_MaxWordLength": "Kein einzelnes Wort darf mehr als {} Zeichen haben",
  "Branding_Validation_MaxLength": "Sollte {} Zeichen nicht überschreiten",
  "NAME": "BrandingLanguage"
}